/** Préférences globales du navigateur (non chiffrées, non liées à un compte). */

const REGISTRATION_KEY = 'terminal.nsi:registration';

export function isRegistrationOpen(): boolean {
  try {
    return localStorage.getItem(REGISTRATION_KEY) !== 'closed';
  } catch {
    return true;
  }
}

export function setRegistrationOpen(open: boolean): void {
  try {
    localStorage.setItem(REGISTRATION_KEY, open ? 'open' : 'closed');
  } catch {
    /* stockage indisponible */
  }
}
